"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionNames = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var QuestionNames;
(function (QuestionNames) {
    QuestionNames["Scratch"] = "scratch";
    QuestionNames["SctatchYes"] = "scratch-yes";
    QuestionNames["AppName"] = "app-name";
    QuestionNames["Folder"] = "folder";
    QuestionNames["ProjectPath"] = "projectPath";
    QuestionNames["ProgrammingLanguage"] = "programming-language";
    QuestionNames["ProjectType"] = "project-type";
    QuestionNames["Capabilities"] = "capabilities";
    QuestionNames["TeamsAppType"] = "teams-app-type";
    QuestionNames["TeamsCapability"] = "teams-capability";
    QuestionNames["BotTrigger"] = "bot-host-type-trigger";
    QuestionNames["Runtime"] = "runtime";
    QuestionNames["SPFxSolution"] = "spfx-solution";
    QuestionNames["SPFxInstallPackage"] = "spfx-install-latest-package";
    QuestionNames["SPFxFramework"] = "spfx-framework-type";
    QuestionNames["SPFxWebpartName"] = "spfx-webpart-name";
    QuestionNames["SPFxWebpartDesc"] = "spfx-webpart-desp";
    QuestionNames["SPFxFolder"] = "spfx-folder";
    QuestionNames["OfficeAddinFolder"] = "addin-project-folder";
    QuestionNames["OfficeAddinManifest"] = "addin-project-manifest";
    QuestionNames["OfficeAddinTemplate"] = "addin-template-select";
    QuestionNames["OfficeAddinHost"] = "addin-host";
    QuestionNames["OfficeAddinImport"] = "addin-import";
    QuestionNames["OfficeAddinFramework"] = "office-addin-framework-type";
    QuestionNames["Samples"] = "samples";
    QuestionNames["ReplaceContentUrl"] = "replaceContentUrl";
    QuestionNames["ReplaceWebsiteUrl"] = "replaceWebsiteUrl";
    QuestionNames["ReplaceBotIds"] = "replaceBotIds";
    QuestionNames["SafeProjectName"] = "safeProjectName";
    QuestionNames["SolutionName"] = "solutionName";
    QuestionNames["RepalceTabUrl"] = "tdp-tab-url";
    QuestionNames["ValidateMethod"] = "validate-method";
    QuestionNames["AppPackagePath"] = "appPackagePath";
    QuestionNames["FromExistingApi"] = "from-existing-api";
    QuestionNames["SearchOpenAPISpecQuery"] = "search-openapi-spec-query";
    QuestionNames["SelectOpenApiSpec"] = "select-openapi-spec";
    QuestionNames["OpenAPISpecType"] = "openapi-spec-type";
    QuestionNames["ApiSpecLocation"] = "openapi-spec-location";
    QuestionNames["ApiOperation"] = "api-operation";
    QuestionNames["ActionManifestPath"] = "external-api-plugin-manifest-path";
    QuestionNames["MeArchitectureType"] = "me-architecture";
    QuestionNames["ApiSpecApiKey"] = "api-key";
    QuestionNames["ApiSpecApiKeyConfirm"] = "api-key-confirm";
    QuestionNames["ApiAuth"] = "api-auth";
    QuestionNames["OauthClientSecret"] = "oauth-client-secret";
    QuestionNames["OauthClientId"] = "oauth-client-id";
    QuestionNames["OauthConfirm"] = "oauth-confirm";
    QuestionNames["CustomCopilotRag"] = "custom-copilot-rag";
    QuestionNames["CustomCopilotAssistant"] = "custom-copilot-agent";
    QuestionNames["LLMService"] = "llm-service";
    QuestionNames["OpenAIKey"] = "openai-key";
    QuestionNames["OpenAIEmbeddingModel"] = "openai-embedding-model";
    QuestionNames["OpenAIAssistantID"] = "openai-assistant-id";
    QuestionNames["AzureOpenAIKey"] = "azure-openai-key";
    QuestionNames["AzureOpenAIEndpoint"] = "azure-openai-endpoint";
    QuestionNames["AzureOpenAIDeploymentName"] = "azure-openai-deployment-name";
    QuestionNames["AzureOpenAIEmbeddingDeploymentName"] = "azure-openai-embedding-deployment-name";
    QuestionNames["AzureOpenAIAssistantId"] = "azure-openai-assistant-id";
    QuestionNames["AzureAISearchApiKey"] = "azure-ai-search-api-key";
    QuestionNames["AzureAISearchEndpoint"] = "azure-ai-search-endpoint";
    QuestionNames["FoundryEndpoint"] = "foundry-endpoint";
    QuestionNames["FoundryAgentId"] = "foundry-agent-id";
    QuestionNames["Features"] = "features";
    QuestionNames["Env"] = "env";
    QuestionNames["SourceEnvName"] = "sourceEnvName";
    QuestionNames["TargetEnvName"] = "targetEnvName";
    QuestionNames["TargetResourceGroupName"] = "targetResourceGroupName";
    QuestionNames["NewResourceGroupName"] = "newResourceGroupName";
    QuestionNames["NewResourceGroupLocation"] = "newResourceGroupLocation";
    QuestionNames["NewTargetEnvName"] = "newTargetEnvName";
    QuestionNames["ExistingTabEndpoint"] = "existing-tab-endpoint";
    QuestionNames["TeamsAppManifestFilePath"] = "manifest-path";
    QuestionNames["LocalTeamsAppManifestFilePath"] = "local-manifest-path";
    QuestionNames["AadAppManifestFilePath"] = "manifest-file-path";
    QuestionNames["TeamsAppPackageFilePath"] = "app-package-file-path";
    QuestionNames["ConfirmManifest"] = "confirmManifest";
    QuestionNames["ConfirmLocalManifest"] = "confirmLocalManifest";
    QuestionNames["ConfirmAadManifest"] = "confirmAadManifest";
    QuestionNames["OutputZipPathParamName"] = "output-zip-path";
    QuestionNames["OutputManifestParamName"] = "output-manifest-path";
    QuestionNames["OutputFolderParamName"] = "output-folder";
    QuestionNames["M365Host"] = "m365-host";
    QuestionNames["ManifestPath"] = "manifest-path";
    QuestionNames["ManifestId"] = "manifest-id";
    QuestionNames["TeamsAppId"] = "teams-app-id";
    QuestionNames["TitleId"] = "title-id";
    QuestionNames["UserEmail"] = "email";
    QuestionNames["UninstallMode"] = "mode";
    QuestionNames["UninstallModeManifestId"] = "manifest-id";
    QuestionNames["UninstallModeEnv"] = "env";
    QuestionNames["UninstallModeTitleId"] = "title-id";
    QuestionNames["UninstallOptions"] = "options";
    QuestionNames["UninstallOptionM365"] = "m365-app";
    QuestionNames["UninstallOptionTDP"] = "app-registration";
    QuestionNames["UninstallOptionBot"] = "bot-framework-registration";
    QuestionNames["collaborationAppType"] = "collaborationType";
    QuestionNames["DestinationApiSpecFilePath"] = "destination-api-spec-location";
    QuestionNames["SyncManifest"] = "sync-manifest";
    QuestionNames["ActionType"] = "api-plugin-type";
    QuestionNames["WithPlugin"] = "with-plugin";
    QuestionNames["ImportPlugin"] = "import-plugin";
    QuestionNames["PluginManifestFilePath"] = "plugin-manifest-path";
    QuestionNames["NewPluginManifestFileName"] = "new-plugin-manifest-file-name";
    QuestionNames["PluginOpenApiSpecFilePath"] = "plugin-opeanapi-spec-path";
    QuestionNames["KnowledgeSource"] = "knowledge-source";
    QuestionNames["OneDriveSharePointURL"] = "oneDriveSharePointURL";
    QuestionNames["OneDriveSharePointContent"] = "oneDriveSharePointContent";
    QuestionNames["WebContent"] = "web-content";
    QuestionNames["SearchType"] = "search-type";
    QuestionNames["GCContent"] = "graph-connector-content";
    QuestionNames["GCList"] = "graph-connector-list";
    QuestionNames["GCInput"] = "graph-connector-input";
    QuestionNames["GCName"] = "graph-connector-name";
    QuestionNames["GCConnectionId"] = "graph-connector-connection-id";
    QuestionNames["AuthName"] = "auth-name";
    QuestionNames["TemplateName"] = "template-name";
    QuestionNames["EmbeddedKnowledgeFiles"] = "embedded-knowledge-files";
    QuestionNames["OAuthAuthorizationUrl"] = "oauth-authorization-url";
    QuestionNames["OAuthTokenUrl"] = "oauth-token-url";
    QuestionNames["OAuthRefreshUrl"] = "oauth-refresh-url";
    QuestionNames["OAuthScope"] = "oauth-scope";
    QuestionNames["OauthPKCE"] = "oauth-pkce";
    QuestionNames["ApiKeyIn"] = "api-key-in";
    QuestionNames["ApiKeyName"] = "api-key-name";
    QuestionNames["TypeSpecProjectType"] = "type-spec-project-type";
    QuestionNames["DeclarativeAgentManifestPath"] = "declarative-agent-manifest-path";
    QuestionNames["SensitivityLabel"] = "sensitivity-label";
    QuestionNames["ShareOperation"] = "share-operation";
    QuestionNames["ShareScope"] = "scope";
    QuestionNames["RemoveUsers"] = "users";
    QuestionNames["SelectPluginManifest"] = "select-plugin-manifest";
    QuestionNames["SelectOpenAPISpecFromPlugin"] = "select-openapi-spec-from-plugin";
    QuestionNames["SelectPluginId"] = "select-plugin-id";
    QuestionNames["DAMetaOSCapability"] = "da-meta-os-capability";
    QuestionNames["MCPServerType"] = "mcp-server-type";
    QuestionNames["MCPLocalServer"] = "mcp-local-server";
    QuestionNames["MCPLocalServerIdentifier"] = "mcp-local-server-identifier";
    QuestionNames["MCPForDAServerUrl"] = "mcp-da-server-url";
    QuestionNames["MCPForDAServerName"] = "mcp-da-server-name";
    QuestionNames["MCPForDATool"] = "mcp-da-tool";
    QuestionNames["MCPForDAAvailableTools"] = "mcp-da-available-tools";
    QuestionNames["MCPForDAPreFetchTools"] = "mcp-da-pre-fetch-tools";
    QuestionNames["MCPForDAAuth"] = "mcp-da-auth";
    QuestionNames["MCPForDAAuthMetadataUrl"] = "mcp-da-auth-metadata-url";
    QuestionNames["MCPForDAAuthWellKnownUrl"] = "mcp-da-auth-well-known-url";
    QuestionNames["MCPForDAAuthType"] = "mcp-da-auth-type";
    QuestionNames["MCPToolsFilePath"] = "mcp-tools-file-path";
})(QuestionNames || (exports.QuestionNames = QuestionNames = {}));
//# sourceMappingURL=questionNames.js.map